<template>
  <div>
    <div class="container" style="text-align:left">
      <div class="row">
        <div class="col">
          <div class="section-header">
            <h2>Terms & Conditions</h2>
          </div>
        </div>
      </div>

      <div class="row" style="text-align:left">
        <div class="col" style="text-align:left">
          <div v-html="terms.termsConditions" id="htmlContainer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  mounted() {
    this.populateTerms();
  },
  methods: {
    ...mapActions("termsConditions", ["retrieveTerms"]),
    async populateTerms() {
      await this.retrieveTerms();
    }
  },
  computed: {
    ...mapGetters("termsConditions", ["getTermsAndConditions"]),
    ...mapState("termsConditions", ["terms"])
  }
};
</script>

<style lang="scss" scoped></style>
